import type { FaireProductEntity } from "../../entity_types/product";

export const p_rbmbdt7xzh: FaireProductEntity = {
  token: "p_rbmbdt7xzh",
  type: "product",
  name: "Needoh Era- Needoh Sticker/Magnet",
  brandToken: "b_vnr7n3htee",
  brandName: "Oily Graphic Creations",
  imageUrl:
    "https://cdn.faire.com/fastly/dc5415c741bb7a3df04bafbe9a8121f69830b53491e572fa9ffe27156073b392.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc3dc91603b832f7126a716257ad00613ae35a23fc59bb146a31ce50d0ff3b8c.png",
    "https://cdn.faire.com/fastly/3d2440ff0da33ab5792a882f43783458ff879dd2933835690084c3fb570316ec.png",
  ],
  priceDollars: 1.2,
  description:
    "You have 4 choices of material....\n\n-Glossy/Matte vinyl is waterproof and good for tumblers, mugs, or anything that will get wet and is good for outdoor use.\n-Holographic is very durable, tear-free, and waterproof. Great for outdoor use.\n-Magnet. It is good for using indoors. It is not waterproof, so it is not recommended for outdoor use. \n\nSize is 3x2.4in",
  tags: [],
  msrpDollars: 3.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:42.466Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
